var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"85b0bdca605b261c8fcff074ad80d5c015afa845"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import { RewriteFrames } from "@sentry/integrations"
import * as Sentry from "@sentry/nextjs"
import { ignoreErrorsList } from "./sentry.server.config"

const NODE_ENV = process.env.NODE_ENV
const SENTRY_DSN = process.env.NEXT_PUBLIC_SENTRY_DSN
const SENTRY_ENVIRONMENT = process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT

Sentry.init({
  enabled: NODE_ENV === "production",
  dsn: SENTRY_DSN,

  // If the entire session is not sampled, use the below sample rate to sample
  // sessions when an error occurs.
  replaysOnErrorSampleRate: 0.1,

  integrations: [
    new Sentry.BrowserTracing(),
    new RewriteFrames({
      iteratee: (frame) => {
        frame.filename.replace("%5B", "[").replace("%5D", "]")

        return frame
      },
    }),
    new Sentry.Replay(),
  ],
  tracesSampleRate: 0.1,
  environment: SENTRY_ENVIRONMENT,
  maxValueLength: 2000,
  ignoreErrors: ignoreErrorsList,

  beforeSend(event) {
    // Check if it's an error and has a request URL
    if (event.request && event.request.url) {
      if (event.request.url.indexOf("chrome-extension://") >= 0) {
        return null // Ignore the event
      }
    }

    // Also check stack trace frames
    if (
      event.exception &&
      event.exception.values &&
      event.exception.values.length > 0
    ) {
      const firstException = event.exception.values[0]
      const frames = firstException.stacktrace?.frames

      if (frames) {
        for (const frame of frames) {
          if (
            frame.filename &&
            frame.filename.indexOf("chrome-extension://") >= 0
          ) {
            return null // Ignore
          }
        }
      }
    }

    // Otherwise, keep the event
    return event
  },
})
